import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { all } from 'redux-saga/effects';
import configureStore from '../helpers/configureStore';
import loading from '../reducers/loading';
import loadingSaga from '../sagas/loadingSaga';
import LoadingPane from '../components/loading/LoadingPane';
import schoolEntry from '../reducers/school_entry';
import schoolAutoSuggest from '../reducers/schoolAutoSuggest';
import saga from '../sagas/schoolEntrySaga';
import schoolAutoSuggestSaga from '../sagas/schoolAutoSuggestSaga';
import postCodeSaga from '../sagas/postCodeSaga';
import student from '../reducers/student';
import studentSaga from '../sagas/studentSaga';
import IndexForm from '../components/school_entry/IndexForm';
import RecommendLoginPopover from '../components/school_entry/RecommendLoginPopover';

function* rootSaga() {
  yield all([saga(), schoolAutoSuggestSaga(), postCodeSaga(), loadingSaga(), studentSaga()]);
}
const store = configureStore({
  schoolEntry, schoolAutoSuggest, loading, student,
}, rootSaga);
const targetNode = document.getElementById('schoolEntryIndexForm');
let initialValues = JSON.parse(targetNode.getAttribute('data-initial-values'));
if (initialValues.student !== undefined && initialValues.student.birthday !== undefined) {
  const [birthday_year, birthday_month, birthday_day] = initialValues.student.birthday.split('-').map((x) => x.replace(/^0/, ''));
  initialValues = {
    ...initialValues,
    birthday_year,
    birthday_month,
    birthday_day,
  };
}

createRoot(targetNode).render(
  <Provider store={store}>
    <LoadingPane />
    <RecommendLoginPopover />
    <IndexForm
      initialValues={{
        authenticity_token: targetNode.getAttribute('data-authenticity-token'),
        ...initialValues,
      }}
      hiddenFields={targetNode.innerHTML}
      displays={JSON.parse(targetNode.getAttribute('data-displays'))}
      loggedIn={targetNode.getAttribute('data-logged-in') === 'true'}
      initialPcTypes={JSON.parse(targetNode.getAttribute('data-pc-types'))}
      initialIsFreeTrial={targetNode.getAttribute('data-is-free-trial') === 'true'}
      paymentStartDate={new Date(targetNode.getAttribute('data-payment-start-date'))}
      linkSvgPath={targetNode.getAttribute('data-link-svg-path')}
      linkPngPcPath={targetNode.getAttribute('data-link-png-pc-path')}
      linkPngSpPath={targetNode.getAttribute('data-link-png-sp-path')}
    />
  </Provider>
);
